import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../login/styles.css"; // Tiếp tục dùng chung CSS để đồng bộ
import { db } from "../../assets/firebase/firebaseconfig";
import {
  ref,
  push,
  query,
  orderByChild,
  equalTo,
  get,
} from "firebase/database";
import { Helmet } from "react-helmet-async";
import Loading from "../Loading";
const Register = () => {
  const [formData, setFormData] = useState({
    username: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // Xóa lỗi khi người dùng bắt đầu sửa lại ô đó
    if (errors[name]) setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    setErrors({}); // Reset lỗi trước khi kiểm tra
    let tempErrors = {};
    // 1. Kiểm tra mật khẩu khớp nhau
    if (formData.username.length < 3) {
      tempErrors.username = "Tên đăng nhập phải có ít nhất 3 ký tự!";
    }
    if (!/^\d{10}$/.test(formData.phone)) {
      tempErrors.phone = "Số điện thoại phải đủ 10 chữ số!";
    }
    if (formData.password.length < 6) {
      tempErrors.password = "Mật khẩu phải từ 6 ký tự trở lên!";
    }
    if (formData.password !== formData.confirmPassword) {
      tempErrors.confirmPassword = "Mật khẩu xác nhận không khớp!";
    }

    // Nếu có lỗi thì dừng lại và hiển thị
    if (Object.keys(tempErrors).length > 0) {
      setErrors(tempErrors);
      return;
    }

    setLoading(true);

    try {
      // 2. Kiểm tra trùng số điện thoại trên Firebase
      const userRef = ref(db, "users");
      const phoneQuery = query(
        userRef,
        orderByChild("phone"),
        equalTo(formData.phone)
      );
      const snapshot = await get(phoneQuery);
      ``;
      if (snapshot.exists()) {
        setErrors({ phone: "Số điện thoại này đã được đăng ký!" });
        setLoading(false);
        return;
      }

      // 3. Đăng ký thành công
      await push(userRef, {
        username: formData.username,
        phone: formData.phone,
        password: formData.password,
        role: "User",
        createdAt: Date.now(),
      });

      alert("Chúc mừng! Bạn đã đăng ký thành công.");
      setFormData({
        username: "",
        phone: "",
        password: "",
        confirmPassword: "",
      });
      setTimeout(() => {
        navigate("/dang-nhap");
      }, 1000);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
if(loading) return <Loading />
  return (
    <div className="login-container">
      <Helmet>
        <title key="register">Đăng ký</title>
      </Helmet>
      <div className="login-card">
        <div className="login-header">
          <h2>Đăng ký tài khoản</h2>
          <p>Chỉ mất 30 giây để bắt đầu mua sắm</p>
        </div>

        <form
          className="login-form"
          noValidate
          autoComplete="off"
          onSubmit={handleSubmit}
        >
          <div className="form-group">
            <label>Tên đăng nhập</label>
            <input
              name="username"
              type="text"
              value={formData.username}
              placeholder="Nhập tên đăng nhập"
              className={errors.username ? "input-error" : ""}
              onChange={(e) =>
                setFormData({ ...formData, username: e.target.value })
              }
            />
            {errors.username && (
              <span className="error-text">{errors.username}</span>
            )}
          </div>

          <div className="form-group">
            <label>Số điện thoại</label>
            <input
              name="phone"
              type="text"
              value={formData.phone}
              placeholder="09xxxxxxxx"
              className={errors.phone ? "input-error" : ""}
              onChange={(e) =>
                setFormData({ ...formData, phone: e.target.value })
              }
            />
            {errors.phone && <span className="error-text">{errors.phone}</span>}
          </div>

          <div className="form-group">
            <label>Mật khẩu</label>
            <input
              name="password"
              type="password"
              value={formData.password}
              placeholder="••••••••"
              className={errors.password ? "input-error" : ""}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
            />
            {errors.password && (
              <span className="error-text">{errors.password}</span>
            )}
          </div>

          <div className="form-group">
            <label>Nhập lại mật khẩu</label>
            <input
              name="confirmPassword"
              type="password"
              value={formData.confirmPassword}
              placeholder="••••••••"
              className={errors.confirmPassword ? "input-error" : ""}
              onChange={(e) =>
                setFormData({ ...formData, confirmPassword: e.target.value })
              }
            />
            {errors.confirmPassword && (
              <span className="error-text">{errors.confirmPassword}</span>
            )}
          </div>

          <button
            type="submit"
            className={`login-button ${loading ? "btn-loading" : ""}`}
            disabled={loading}
          >
            {loading ? "Đang tạo..." : "Đăng ký ngay"}
          </button>
        </form>

        <p className="register-text">
          Đã có tài khoản? <Link to="/dang-nhap">Đăng nhập ngay</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
